var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component } from 'vue-property-decorator';
import { Button } from 'vant';
import { MOBILE_REG } from '@lhb/regexp';
import { setCookie, removeCookie, getCookie } from '@/common/utils/tools';
import Input from '@/common/components/Input/index.vue';
var QuickNav = /** @class */ (function (_super) {
    __extends(QuickNav, _super);
    function QuickNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            mobile: '17777777777',
            code: '888888'
        };
        _this.enterprisesList = [];
        _this.projectText = '邻汇吧';
        return _this;
    }
    QuickNav.prototype.changeProject = function () {
        if (getCookie('test-customized-project')) {
            removeCookie('test-customized-project');
        }
        else {
            setCookie('test-customized-project', 'xtc');
        }
        setTimeout(function () {
            window.location.reload();
        }, 1);
    };
    QuickNav.prototype.created = function () {
        if (getCookie('test-customized-project') === 'xtc') {
            this.projectText = '小天才';
        }
    };
    QuickNav.prototype.codeLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, token, enterprisesData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!MOBILE_REG.test(this.formData.mobile)) {
                            this.$toast('请输入正确的手机号码');
                            return [2 /*return*/];
                        }
                        // 调用发送验证码接口
                        return [4 /*yield*/, this.$post("/v2/auth/send/code", { mobile: this.formData.mobile }, {
                                isTerra: true
                            }
                            // { isSelf: false }
                            )];
                    case 1:
                        // 调用发送验证码接口
                        _a.sent();
                        return [4 /*yield*/, this.$post("/v2/auth/login", this.formData, {
                                isTerra: true
                            }
                            // { isSelf: false }
                            )];
                    case 2:
                        data = (_a.sent()).data;
                        token = data.token;
                        setCookie('localUimsToken', token);
                        this.$toast("\u767B\u5F55\u6210\u529F");
                        return [4 /*yield*/, this.$get("/v2/auth/tenant/list", {}, {
                                isTerra: true
                            })];
                    case 3:
                        enterprisesData = (_a.sent()).data;
                        this.enterprisesList = enterprisesData;
                        return [2 /*return*/];
                }
            });
        });
    };
    QuickNav.prototype.logoutHandle = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$get("/v2/auth/logout", {}, { isTerra: true })];
                    case 1:
                        _a.sent();
                        this.enterprisesList = [];
                        removeCookie('localUimsToken');
                        return [2 /*return*/];
                }
            });
        });
    };
    // 切换企业
    QuickNav.prototype.changeEnterprise = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var data, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$post("/v2/auth/tenant/choose", { tenantId: item.id }, { isTerra: true })];
                    case 1:
                        data = (_a.sent()).data;
                        token = data.token;
                        // setCookie('localToken', token);
                        setCookie('localUimsToken', token);
                        this.$toast("\u4F01\u4E1A\u5207\u6362\u6210\u529F");
                        return [2 /*return*/];
                }
            });
        });
    };
    QuickNav = __decorate([
        Component({
            components: {
                Input: Input,
                VanButton: Button
            }
        })
    ], QuickNav);
    return QuickNav;
}(Vue));
export default QuickNav;
